import { render } from "./SettingPageLinkWithIcon.vue?vue&type=template&id=668a2383"
import script from "./SettingPageLinkWithIcon.vue?vue&type=script&lang=js"
export * from "./SettingPageLinkWithIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__